export const formatArea = (number?: number) => (number ? `${number} m2` : '');
